// import HeroSection from '@/components/ui/Homepage/Herosection'
import React from 'react'
import MainProducts from "@/components/ui/Homepage/MainProducts";
// import ShopByCategory from "@/components/ui/Homepage/ShopByCategory";
// import HomeAbout from "@/components/ui/Homepage/HomeAbout";
// import HappyCustomerReviews from "@/components/ui/Homepage/HappyCustomerReviews";
import InstagramFeed from "@/components/ui/Homepage/InstagramFeed";
import TrendingProducts from "@/components/ui/Homepage/TrendingProducts";
import StoresInfo from "@/components/ui/Homepage/StoresInfo/StoresInfo";
import BakeloreIntro from "@/components/ui/Homepage/BakeloreIntro/BakeloreIntro";
import FloatingOrderButton from "@/components/ui/Homepage/FloatingOrderButton/FloatingOrderButton";
import Testimonial from "@/components/ui/Homepage/Testimonial/Testimonial";
import HeroSection from '@/components/ui/Landingpage/Herosecction';

 const slidesData = [
  {
    desktop: "https://bakelore.com/images/bakelore-website-012.jpg",
    mobile: "https://bakelore.com/images/bakelore-hero-cakes-mobile-02.jpg",
  },
  {
    desktop: "https://bakelore.com/images/strawberry-cake-bakelore-02.png",
    mobile: "https://bakelore.com/images/bakelore-hero-cakes-mobile-02.jpg",
  },
  {
    desktop: "https://bakelore.com/images/bakelore-hero-cakes.jpg",
    mobile: "https://bakelore.com/images/bakelore-hero-cakes-mobile-02.jpg",
  },
];

const Landingpage = () => {
  return (
    <div>
             
{/* <HeroSection
        slides={slidesData}
        bannerLink="#"
        autoSlide={true}
        intervalTime={4000}


      /> */}
      <HeroSection/>

       {/* <AboutSection /> */}
                   <TrendingProducts/>

      

            <BakeloreIntro />
      
            <FloatingOrderButton/>
      
            <Testimonial />
            {/* <HomeAbout /> */}
            <MainProducts />
      
            {/* <HappyCustomerReviews /> */}
            <InstagramFeed />
  
    </div>
  )
}

export default Landingpage